import {
  quoteExactBuyIntent as buyIntent,
  quoteExactSellIntent as sellIntent,
  quoteExactSwapIntent as swapIntent,
} from '@morfi/market-math';
import { marketPoolQuoteContextAtTime } from './quote-operation.js';

type QuoteTime = { readonly quoteUnixTimestampSeconds?: bigint };

export function quoteExactBuyIntent(
  input: Parameters<typeof buyIntent>[0] & QuoteTime,
): ReturnType<typeof buyIntent> {
  return buyIntent({
    ...input,
    outcome: {
      ...input.outcome,
      context: marketPoolQuoteContextAtTime(
        input.outcome.context,
        input.quoteUnixTimestampSeconds ?? input.outcome.context.quoteUnixTimestampSeconds,
      ),
    },
  });
}

export function quoteExactSellIntent(
  input: Parameters<typeof sellIntent>[0] & QuoteTime,
): ReturnType<typeof sellIntent> {
  return sellIntent({
    ...input,
    outcome: {
      ...input.outcome,
      context: marketPoolQuoteContextAtTime(
        input.outcome.context,
        input.quoteUnixTimestampSeconds ?? input.outcome.context.quoteUnixTimestampSeconds,
      ),
    },
  });
}

export function quoteExactSwapIntent(
  input: Parameters<typeof swapIntent>[0] & QuoteTime,
): ReturnType<typeof swapIntent> {
  const quoteUnixTimestampSeconds =
    input.quoteUnixTimestampSeconds ??
    input.source.context.quoteUnixTimestampSeconds ??
    BigInt(Math.floor(Date.now() / 1000));
  return swapIntent({
    ...input,
    source: {
      ...input.source,
      context: marketPoolQuoteContextAtTime(input.source.context, quoteUnixTimestampSeconds),
    },
    destination: {
      ...input.destination,
      context: marketPoolQuoteContextAtTime(input.destination.context, quoteUnixTimestampSeconds),
    },
  });
}
